import { Component } from "@angular/core";
import { AppRoutes } from "src/app/constants";

@Component({
  selector: "app-logo",
  templateUrl: "./logo.page.html",
  styleUrls: ["./logo.page.scss"],
})
export class LogoPage {
  public routes: typeof AppRoutes = AppRoutes;
  public avatarImagePath: string;

  public user = {
    name: "Anna Reckless",
    avatarImage: "anna.svg",
  };

  public breadcrumbs = [
    {
      name: "Mein Betrieb",
      link: "/settings",
    },
  ];

  constructor() {
    this.avatarImagePath = `./assets/avatar/${this.user.avatarImage}`;
  }
}
